import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import ChildTabViewModel from "./../../factories/child-tab-view-model";
import "./../../bindings/bao-toolbar2";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-number-box";
import "./../../bindings/bao-pager";
import "./../../bindings/bao-upload";
function ConfigurationItemReminderTabModel(tabPage, parent) {
    var self = this;
    ChildTabViewModel.call(self, tabPage);
    self.Bao = Bao;
    self.ConfigurationItem = parent;
    self.CompleteCheck = function () {
        return true;
    };
    self.RefreshInProgress = ko.observable(false);
    self.PageIndex = ko.observable(0);
    self.PageIndex.subscribe(function () {
        self.RefreshGrid();
    });
    self.PageSize = ko.observable(10);
    self.TotalRows = ko.observable(0);
    self.Sorting = ko.observableArray();
    self.Sorting.subscribe(function () {
        self.RefreshGrid();
    });
    self.ReminderCollection = ko.observableArray([]);
    self.ShowCompletedReminders = ko.observable();
    self.ShowCompletedReminders.subscribe(function () {
        self.RefreshGrid();
    });
    self.SelectedReminderRow = ko.observable({});
    self.SelectedReminderRow.subscribe(function () {
        if (self.SelectedReminderRow() == null) {
            self.enableDisableButton("EditConfigurationItemReminder", false);
            self.enableDisableButton("DeleteConfigurationItemReminder", false);
        }
        else {
            self.enableDisableButton("EditConfigurationItemReminder", true);
            self.enableDisableButton("DeleteConfigurationItemReminder", true);
        }
    });
    var _deleteMessage = Bao.Session.GetMessage("msgDeleteConfigurationItemReminder");
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "AddConfigurationItemReminder":
                self.ShowConfigurationItemReminderDialog(self.ConfigurationItem.ConfigurationItemId(), null);
                break;
            case "EditConfigurationItemReminder":
                if (self.SelectedReminderRow() != null) {
                    self.EditConfigurationItemReminder(self.SelectedReminderRow());
                }
                break;
            case "DeleteConfigurationItemReminder":
                var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessage, "yesno");
                yesNoDialog.DialogResult.subscribe(function (result) {
                    if (result === true) {
                        self.DeleteConfigurationItemReminder(self.ConfigurationItem.ConfigurationItemId(), self.SelectedReminderRow().ConfigurationItemReminderId);
                    }
                });
                break;
        }
    };
    self.RefreshGrid = function () {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemTab/GetConfigurationItemReminderCollection", JSON.stringify({
            sessionTabId: self.ConfigurationItem.TabPage.SessionTabId,
            configurationItemId: self.ConfigurationItem.ConfigurationItemId(),
            showCompletedReminders: self.ShowCompletedReminders(),
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize(),
            sorting: self.Sorting()
        }), function (searchResult) {
            tabPage.IsLoading(false);
            self.SelectedReminderRow(null);
            self.TotalRows(0);
            self.ReminderCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.ReminderCollection(searchResult.Models);
                self.TotalRows(searchResult.TotalRows);
            }
        });
    };
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    self.AddConfigurationItemReminder = function (model, configurationItemId) {
        tabPage.IsLoading(true);
        Bao.post("ConfigurationItemTab/AddConfigurationItemReminder", JSON.stringify({
            sessionTabId: self.ConfigurationItem.TabPage.SessionTabId,
            reminderModel: ko.map.toJS(model, true),
            configurationItemId: configurationItemId
        }), function () {
            self.ConfigurationItem.TabPage.DirtyFlag(true);
            if (model.IsComplete() == true && (model.IsCompleteDefault() == null || model.IsCompleteDefault() == false) && model.ReminderInterval() != null && model.ReminderInterval() > 0) {
                tabPage.IsLoading(false);
                var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("ReminderExtend"), "yesno");
                yesNoDialog.DialogResult.subscribe(function (result) {
                    if (result === true) {
                        tabPage.IsLoading(true);
                        Bao.post("ConfigurationItemTab/ExtendConfigurationItemReminder", JSON.stringify({
                            sessionTabId: self.ConfigurationItem.TabPage.SessionTabId,
                            reminderModel: ko.map.toJS(model),
                            configurationItemId: configurationItemId
                        }), function () {
                            self.RefreshGrid();
                        });
                    }
                    else {
                        self.RefreshGrid();
                    }
                });
            }
            else {
                self.RefreshGrid();
            }
        });
    };
    self.DeleteConfigurationItemReminder = function (configurationItemId, configurationItemReminderId) {
        self.RefreshInProgress(true);
        Bao.post("ConfigurationItemTab/DeleteConfigurationItemReminder", JSON.stringify({
            sessionTabId: self.ConfigurationItem.TabPage.SessionTabId,
            configurationItemId: configurationItemId,
            configurationItemReminderId: configurationItemReminderId
        }), function () {
            self.RefreshInProgress(false);
            self.ConfigurationItem.TabPage.DirtyFlag(true);
            self.RefreshGrid();
        });
    };
    self.EditConfigurationItemReminder = function (item) {
        self.ShowConfigurationItemReminderDialog(self.ConfigurationItem.ConfigurationItemId(), item.ConfigurationItemReminderId);
    };
    self.ShowConfigurationItemReminderDialog = function (configurationItemId, configurationItemReminderId) {
        window.baorequire(["ViewModels/Dialogs/ConfigurationItemReminderDialog"], function (vm) {
            var dialog = new vm(tabPage, self);
            dialog.Show(configurationItemId, configurationItemReminderId);
            dialog.DialogResult.subscribe(function (dialogResult) {
                if (dialogResult == "ok") {
                    self.AddConfigurationItemReminder(dialog.DialogViewModel, self.ConfigurationItem.ConfigurationItemId());
                }
            });
        });
    };
    self.enableDisableButton = function (actionKey, enabled) { };
    self.Refresh = function () {
        var def = $.Deferred();
        self.RefreshGrid().then(function () {
            def.resolve();
        });
        return def.promise();
    };
    self.Save = function () {
        var def = $.Deferred();
        def.resolve();
        return def.promise();
    };
    self.loaded = function () {
        return self.Refresh();
    };
}
;
Bao.inherit(ConfigurationItemReminderTabModel, ChildTabViewModel);
export default ConfigurationItemReminderTabModel;